import { ComponentType } from 'react'
import { GridCellProps } from '@progress/kendo-react-grid'
import { DocumentDto } from 'api/Documents/Types/Document'

interface ExpandDetailsCellProps extends GridCellProps {
  expandChange(data: DocumentDto): void
}

export const ExpandDetailCell: ComponentType<ExpandDetailsCellProps> = (props) => {
  const document: DocumentDto = props.dataItem
  if (!document.relations.length) {
    return <td className='k-hierarchy-cell has-pointer' />
  }
  return (
    <td className='k-hierarchy-cell has-pointer'>
      {document.expanded ? (
        <span
          onClick={() => props.expandChange({ ...document, expanded: false })}
          className='k-icon k-minus'
          tabIndex={-1}
        />
      ) : (
        <span
          onClick={() => props.expandChange({ ...document, expanded: true })}
          className='k-icon k-plus'
          tabIndex={-1}
        />
      )}
    </td>
  )
}
